import { Button, Group, Modal, Stack, Text } from "@mantine/core";

interface DiscardBypassPrefixChangesModalProps {
  opened: boolean;
  onCancel: () => void;
  onDiscard: () => void;
}

export default function DiscardBypassPrefixChangesModal({
  opened,
  onCancel,
  onDiscard,
}: DiscardBypassPrefixChangesModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onCancel}
      title="Discard unsaved changes?"
      centered
    >
      <Stack gap="md">
        <Text size="sm">
          Your staged bypass-prefix changes have not been saved.
        </Text>
        <Group justify="flex-end">
          <Button variant="default" onClick={onCancel}>
            Keep editing
          </Button>
          <Button color="red" onClick={onDiscard}>
            Discard changes
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
